import { useState } from "react";
import styles from "./WeatherCard.module.scss";
import refreshImg from "../../images/Svg/refresh.svg";
import { ReactComponent as RefreshImg } from "../../images/Svg/refresh.svg";

export const WeatherCard = ({
  data,
  onRefresh,
  onDelete,
  onOpen,
  onToggleSeeMore,
  isLiked,
  onToggleLike,
  onHourlyForecast,
}) => {
  const [spin, setSpin] = useState(false);
  const [heartAnim, setHeartAnim] = useState(false);
  const cityTimestamp = (data.dt + data.timezone) * 1000;

  const formattedDate = new Intl.DateTimeFormat("en-GB", {
    timeZone: "UTC",
  }).format(cityTimestamp);
  const dayName = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    timeZone: "UTC",
  }).format(cityTimestamp);
  const timeString = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC",
  }).format(cityTimestamp);

  return (
    <div className={styles.weatherCard} onClick={onOpen}>
      <div className={styles.upperDiv}>
        <p className={styles.upperDiv_text}>{data.name}</p>
        <p className={styles.upperDiv_text}>{data.sys.country}</p>
      </div>
      <p className={styles.weatherCard_time}>{timeString}</p>
      <button
        className={styles.weatherCard_forecast}
        onClick={(e) => {
          e.stopPropagation();
          onHourlyForecast();
        }}
      >
        Hourly forecast
      </button>
      <div className={styles.dateDiv}>
        <p className={styles.dateDiv_date}>{formattedDate}</p>
        <div className={styles.dateDiv_line}></div>
        <p className={styles.dateDiv_date}>{dayName}</p>
      </div>
      <div>
        <img
          className={styles.weatherCard_icon}
          src={`http://openweathermap.org/img/wn/${data.weather[0].icon}@4x.png`}
          alt={data.weather[0].description}
        />

        <p className={styles.weatherCard_temp}>
          {Math.round(data.main.temp)}°C
        </p>
      </div>

      <div className={styles.weatherBtnDiv}>
        <RefreshImg
          alt="Refresh"
          className={`${styles.weatherBtnDiv_refresh} ${
            spin ? styles.spin : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            setSpin(true);
            onRefresh(data.name);
            setTimeout(() => setSpin(false), 600);
          }}
        />
        <svg
          viewBox="0 0 24 24"
          className={`${styles.weatherBtnDiv_like} ${
            heartAnim ? styles.heartPop : ""
          } ${isLiked ? styles.liked : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            setHeartAnim(true);
            onToggleLike(data.name);
            setTimeout(() => setHeartAnim(false), 400);
          }}
        >
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
        <button
          className={styles.weatherBtnDiv_seeMore}
          onClick={(e) => {
            e.stopPropagation();
            onToggleSeeMore();
          }}
        >
          See more
        </button>
        <div
          className={styles.trashBox}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(data.name);
            onToggleSeeMore();
          }}
        >
          <div className={styles.trash}></div>
          <div className={styles.trashTop}></div>
          <div className={styles.trashBtm}>
            <div className={styles.trashLines}>
              <div className={styles.trashLine}></div>
              <div className={styles.trashLine}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
